import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import SmallLoader from "../../components/Loaders/SmallLoader";

import { UseStateValue } from "../../state/index";
import { useRouter } from "next/router";
import { redisClient } from "../../db/redis";

import { fetchBookableSports } from "../../util/venues/booking";
import { getSession } from "../../lib/getSession";
import Head from "next/head";
import Layout from "../../layouts/layout";
import OffersList from "../../components/Venues/VenuesBooking/OffersList";
import { toast } from "react-toastify";

const Cart = dynamic(() => import("../../components/Venues/VenuesBooking/Cart"), {
   ssr: false,
   loading: () => <SmallLoader />
});
const VenuesBooking = dynamic(() => import("../../components/Venues/VenuesBooking/VenueBooking"), {
   ssr: false,
   loading: () => <SmallLoader />
});
const BookLoader = dynamic(() => import("../../components/Loaders/BookLoader"), {
   ssr: false,
   loading: () => <SmallLoader />
});
const NextButton = dynamic(() => import("../../components/Venues/VenuesBooking/NextButtton"), {
   ssr: false,
   loading: () => <SmallLoader />
});
const EmptyComponent = dynamic(() => import("../../components/PlaceHolder/EmptyComponent"), {
   ssr: false,
   loading: () => <SmallLoader />
});

const Index = () => {
   const router = useRouter();
   const { venueId } = router?.query;
   const [nextOffer, setNextOffer] = useState("");
   const [{ users, cartData, bookableSports, loader, bookableData }, dispatch] = UseStateValue();

   useEffect(() => {
      dispatch({
         type: "REMOVE_COUPON_CODE",
         payload: ""
      });
      dispatch({
         type: "RESET_INSURANCE",
         payload: ""
      });

      // if (bookableSports?.list?.length > 0) {
      //    console.log('nothing');
      // } else {
      let date = bookableData?.date || moment(new Date()).format("YYYY-MM-DD");
      const mobileNumber = users?.userInfo?.mobile;
      fetchBookableSports(users?.userInfo?.id, users?.token, venueId, date, dispatch, mobileNumber);
      // }
      dispatch({
         type: "SWITCH_LOADER",
         payload: false
      });
   }, []);

   const getNextOffer = nextOffer => {
      setNextOffer(nextOffer);
   };

   // const handleBeforeLeave = () => {
   //    window.dataLayer.push({
   //       event: "exitIntent",
   //       buttonName: "exit_intent"
   //    });
   //    dispatch({ type: "DOWNLOAD_MODAL", payload: { open: true, offer: true } });
   // };

   // useBeforeLeave(handleBeforeLeave);
   // console.log({ nextOffer });


   return bookableSports?.list?.length > 0 ? (
      <div className="relative items-center justify-center w-full h-full   md:mt-10 px-3 py-8 bg-white md:w-11/12 lg:w-9/12 md:px-3 lg:px-8">
         <Head>
            <title>{`Check Real-Time Slots Availability at ${bookableSports.clubName}, ${bookableSports.clubArea} on Playo`}</title>
            <meta
               name="description"
               content={`See available slots, cancellation/reschedule policy, pay and reserve your slots at ${bookableSports.clubName} on Playo`}
            />
         </Head>
         <OffersList getNextOffer={getNextOffer} venueId={venueId} />
         <div className="relative flex flex-col justify-between w-full gap-5 md:flex-row ">
            <div className="w-full ">
               {" "}
               <VenuesBooking />
            </div>

            <div className="hidden w-full md:block">
               <Cart
                  nextOfferText={nextOffer?.currentCouponText}
                  cartData={cartData}
                  dispatch={dispatch}
                  title={"Cart"}
                  users={users}
                  currency={bookableSports?.currency}
                  bookableSports={bookableSports}
               />

               {/* <SummarySection
                  // couponData={couponData}
                  // verifyBooking={verifyBooking}
                  cartData={cartData}
               /> */}
            </div>
         </div>
         <div className="fixed bottom-0 left-0 w-full border-2 md:hidden">
            <NextButton nextOfferText={nextOffer?.nextBestCouponText} />
         </div>
      </div>
   ) : loader?.bookLoader ? (
      <BookLoader />
   ) : (
      <div className="flex flex-col items-center justify-center w-full mt-20 text-xl rounded-md h-80 ">
         <EmptyComponent mt={"mt-64"} message="No Sports Available For Booking" />
      </div>
   );
};

Index.getLayout = function getLayout(page) {
   return (
      <Layout bottomBanner={false} footer={false} headerLogo={false}>
         {page}
      </Layout>
   );
};
export default Index;

export async function getServerSideProps(context) {
   const session = await getSession(context?.req, context?.res);
   const parsedSession = JSON.parse(JSON.stringify(session));
   let users = parsedSession.data || {};
   let allSports = await redisClient.mget(["allsports"], (err, reply) => {
      return reply;
   });
   const [parsedSports] = await Promise.all([JSON.parse(allSports)]);

   return {
      props: {
         allSports: parsedSports,
         footer: false,
         users: users,

         layout: "booking"
         // filter: { sportSelected: ['SP3'] }
      }
   };
}
